import React, { useMemo, useState } from "react";

import { Grid } from "@mui/material";
import MarketTable from "./MarketTable";
import MarketTabs from "./MarketTabs";
import SearchInput from "components/SearchInput";
import { search } from "utils/helpers/search";
import { useSelector } from "react-redux";

function AdvancedTradeMarket() {
  const [value, setValue] = useState();

  const marketLoggedInList = useSelector(
    (state) => state.market.marketLoggedInList?.data
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setValue(value);
  };

  const searchedMarketLoggedInList = useMemo(() => {
    return search({
      list: marketLoggedInList,
      value,
      keys: ["coinSourceName", "coinDestinationName"],
    });
  }, [marketLoggedInList, value]);

  return (
    <Grid container maxHeight="1020px" overflow="auto" pl={2}>
      <Grid item xs={12} mx={1} mb={1}>
        <MarketTabs />
      </Grid>

      <Grid item xs={12} mb={1}>
        <SearchInput value={value} onChange={handleSearch} />
      </Grid>

      <Grid item xs={12}>
        <MarketTable marketLoggedInList={searchedMarketLoggedInList} />
      </Grid>
    </Grid>
  );
}

export default AdvancedTradeMarket;
